import { createContext } from 'react'

const RouterContext = createContext<{ canGoBack(): boolean }>({
  canGoBack: () => false as boolean,
})

export default RouterContext
